import * as Types from '../../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SelectBundleMutationVariables = Types.Exact<{
	bundleShortName: Types.Scalars['String']['input'];
	state: Types.Scalars['Boolean']['input'];
	country: Types.Scalars['Country']['input'];
	platform?: Types.Platform;
}>;

export type SelectBundleMutation = {
	__typename?: 'Mutation';
	setBundle: {
		__typename?: 'UpdateSettingsPayload';
		packages: Array<{
			__typename?: 'Package';
			id: string;
			selected: boolean;
			bundles: Array<{ __typename?: 'Bundle'; id: string; selected: boolean }>;
			addons: Array<{ __typename?: 'Package'; id: string; selected: boolean }>;
		}>;
		settings: {
			__typename?: 'Settings';
			selectedPackages: Array<{ __typename?: 'Package'; id: string; selected: boolean }>;
		};
	};
};

export const SelectBundleDocument = gql`
	mutation SelectBundle($bundleShortName: String!, $state: Boolean!, $country: Country!, $platform: Platform! = WEB) {
		setBundle(input: { state: $state, bundle: $bundleShortName, country: $country, platform: $platform }) {
			packages(country: $country, platform: $platform) {
				id
				selected
				bundles(country: $country, platform: $platform) {
					id
					selected
				}
				addons(country: $country, platform: $platform) {
					id
					selected
				}
			}
			settings {
				selectedPackages(platform: $platform, country: $country) {
					id
					selected
				}
			}
		}
	}
`;
